import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'tgx-xml-redirect',
  templateUrl: './xml-redirect.component.html',
  styleUrls: ['./xml-redirect.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class XmlRedirectComponent {}
